export interface RoomColor {
  name: string;
  dot: string;
  pill: string;
  accent: string;
  checkbox: string;
}

export const ROOM_COLORS: RoomColor[] = [
  {
    name: 'blue',
    dot: 'bg-blue-500',
    pill: 'bg-blue-100 text-blue-900 hover:bg-blue-200',
    accent: 'border-blue-500',
    checkbox:
      'text-blue-500 checked:border-blue-500 checked:bg-blue-500 focus:ring-blue-500',
  },
  {
    name: 'emerald',
    dot: 'bg-emerald-500',
    pill: 'bg-emerald-100 text-emerald-900 hover:bg-emerald-200',
    accent: 'border-emerald-500',
    checkbox:
      'text-emerald-500 checked:border-emerald-500 checked:bg-emerald-500 focus:ring-emerald-500',
  },
  {
    name: 'amber',
    dot: 'bg-amber-500',
    pill: 'bg-amber-100 text-amber-900 hover:bg-amber-200',
    accent: 'border-amber-500',
    checkbox:
      'text-amber-500 checked:border-amber-500 checked:bg-amber-500 focus:ring-amber-500',
  },
  {
    name: 'rose',
    dot: 'bg-rose-500',
    pill: 'bg-rose-100 text-rose-900 hover:bg-rose-200',
    accent: 'border-rose-500',
    checkbox:
      'text-rose-500 checked:border-rose-500 checked:bg-rose-500 focus:ring-rose-500',
  },
  {
    name: 'violet',
    dot: 'bg-violet-500',
    pill: 'bg-violet-100 text-violet-900 hover:bg-violet-200',
    accent: 'border-violet-500',
    checkbox:
      'text-violet-500 checked:border-violet-500 checked:bg-violet-500 focus:ring-violet-500',
  },
  {
    name: 'cyan',
    dot: 'bg-cyan-500',
    pill: 'bg-cyan-100 text-cyan-900 hover:bg-cyan-200',
    accent: 'border-cyan-500',
    checkbox:
      'text-cyan-500 checked:border-cyan-500 checked:bg-cyan-500 focus:ring-cyan-500',
  },
  {
    name: 'orange',
    dot: 'bg-orange-500',
    pill: 'bg-orange-100 text-orange-900 hover:bg-orange-200',
    accent: 'border-orange-500',
    checkbox:
      'text-orange-500 checked:border-orange-500 checked:bg-orange-500 focus:ring-orange-500',
  },
  {
    name: 'lime',
    dot: 'bg-lime-500',
    pill: 'bg-lime-100 text-lime-900 hover:bg-lime-200',
    accent: 'border-lime-500',
    checkbox:
      'text-lime-500 checked:border-lime-500 checked:bg-lime-500 focus:ring-lime-500',
  },
  {
    name: 'fuchsia',
    dot: 'bg-fuchsia-500',
    pill: 'bg-fuchsia-100 text-fuchsia-900 hover:bg-fuchsia-200',
    accent: 'border-fuchsia-500',
    checkbox:
      'text-fuchsia-500 checked:border-fuchsia-500 checked:bg-fuchsia-500 focus:ring-fuchsia-500',
  },
  {
    name: 'teal',
    dot: 'bg-teal-500',
    pill: 'bg-teal-100 text-teal-900 hover:bg-teal-200',
    accent: 'border-teal-500',
    checkbox:
      'text-teal-500 checked:border-teal-500 checked:bg-teal-500 focus:ring-teal-500',
  },
  {
    name: 'indigo',
    dot: 'bg-indigo-500',
    pill: 'bg-indigo-100 text-indigo-900 hover:bg-indigo-200',
    accent: 'border-indigo-500',
    checkbox:
      'text-indigo-500 checked:border-indigo-500 checked:bg-indigo-500 focus:ring-indigo-500',
  },
  {
    name: 'stone',
    dot: 'bg-stone-500',
    pill: 'bg-stone-200 text-stone-900 hover:bg-stone-300',
    accent: 'border-stone-500',
    checkbox:
      'text-stone-500 checked:border-stone-500 checked:bg-stone-500 focus:ring-stone-500',
  },
];
